import { render, staticRenderFns } from "./SettlementPanel.vue?vue&type=template&id=1168d06a&scoped=true"
import script from "./SettlementPanel.vue?vue&type=script&lang=js"
export * from "./SettlementPanel.vue?vue&type=script&lang=js"
import style0 from "./SettlementPanel.vue?vue&type=style&index=0&id=1168d06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168d06a",
  null
  
)

export default component.exports